import { $get } from '../axios';

// 账号设置-修改手机
export const changePhone = params => {
  return $get('/creator/', { act: 'change_phone', ...params });
};
// 账号权益
export const getAccEquity = params => {
  return $get('/creator/', { act: 'get_score_info', ...params });
};
